export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/dry-446dc4be60be5080e0f81e75e79a4d82.svg";